/**
 * Javascript for subscription pages
 */
(function (window, document, $, undefined) {
	"use strict";

	var scoped = $(".template-subscription");
	var registration_page = 1;
	var $registration_form = $(scoped).find(
		"#subscription-preferences-registration",
	);
	var $update_form = $(scoped).find("#subscription-preferences-update");
	var $login_form = $(scoped).find("#subscription-preferences-login");
	var $delete_form = $(scoped).find("#subscription-preferences-delete");
	var $portfolio_managers_section = $(scoped).find(".portfolio-managers");
	var $factsheet_commentaries_section = $(scoped).find(
		".factsheets-commentaries",
	);
	var $document_table = $(scoped).find(".user-factsheets");
	var $subscription_toggle = $(scoped).find(".subscription-toggle__checkbox");
	var $userSignup = $(scoped).find(".user-signup");
	var $dashboard = $(scoped).find(".subscription-preferences-insights");
	var $redirect_prospect_modal = $(scoped).find(
		".subscription-registered-offsite",
	);
	var pardot_data = JSON.parse(window.localized.preferences.session) || {};
	var pardot_data_location_storage =
		JSON.parse(window.localStorage.getItem("pardot-session-data")) || {};
	var $redirect_prospect_modal_form = $(scoped).find(
		"#subscription-preferences-registered-modal",
	);

	$.extend($.expr[":"], {
		containsNC: function (elem, i, match, array) {
			return (
				(elem.textContent || elem.innerText || "")
					.toLowerCase()
					.indexOf((match[3] || "").toLowerCase()) >= 0
			);
		},
	});

	/**
	 * Accessibility
	 * Custom enterKey event that should be on all click events
	 */
	(function ($) {
		$("body").on("keydown", function (ev) {
			if (ev.which == 13) {
				var enterEv = $.extend({}, ev, { type: "enterKey" });
				return $(ev.target).trigger(enterEv);
			}
		});

		$.fn.enterKey = function (selector, data, fn) {
			return this.on("enterKey", selector, data, fn);
		};
	})(jQuery);

	/**
	 * Validate Forms
	 * @param $form
	 * @param formSubmittedEvent
	 * @returns {boolean}
	 */
	window.subscription_validate_form = function ($form, formSubmittedEvent) {
		$form = jQuery($form);
		$form.addClass("has-submitted");
		var $requiredFields = $form.find("[data-required]");
		var $requiredFieldsNotValid = $requiredFields.filter(function () {
			var $input = $(this).is("input, select")
				? $(this)
				: $(this).find("input").first();

			if ($input.is('[type="checkbox"]') && !$input.is(":checked")) {
				return true;
			}

			return !$input.val();
		});

		// Clear all field errors
		$requiredFields.removeClass("error");

		// Add field errors
		$requiredFieldsNotValid.addClass("error");

		// Focus if an error is present
		if (formSubmittedEvent && $requiredFieldsNotValid.length > 0) {
			var $input = $requiredFieldsNotValid.first().is("input, select")
				? $requiredFieldsNotValid.first()
				: $requiredFieldsNotValid.first().find("input").first();
			$input.focus();
		}

		return $requiredFieldsNotValid.length === 0;
	};

	/*** SUBSCRIPTION MODULES ****
	 *****************************
	 *****************************/

	/*** SUBSCRIPTION MODULE - PORTFOLIO MANAGERS ****/
	/**
	 * Portfolio Managers Section
	 * Add a portfolio manager
	 */
	function add_portfolio_manager_to_following(manager_id) {
		// Verify that we are not already following
		if (
			$portfolio_managers_section.find(
				'.portfolio-managers__subscriptions-unfollow[data-id="' +
					manager_id +
					'"]',
			).length === 0
		) {
			var $valueField = $($portfolio_managers_section).find(
				'#template-subscription-portfolio-managers option[value="' +
					manager_id +
					'"]',
			);

			// Show the following row if not already
			$portfolio_managers_section
				.find(".row-following")
				.addClass("row-following--active");

			// Append the data
			$portfolio_managers_section
				.find(".portfolio-managers__following")
				.append(
					'<li data-manager="' +
						manager_id +
						'">' +
						'                                <div class="row">' +
						'                                    <div class="col-lg-3">' +
						'                                        <div class="portfolio-managers__subscriptions-manager-name">' +
						"                                            " +
						$valueField.text() +
						"                                        </div>" +
						"                                    </div>" +
						'                                    <div class="col-lg-9">' +
						'                                        <div class="portfolio-managers__subscriptions-manager-description">' +
						"                                            " +
						portfolio_manager_limit_bio(
							$valueField.attr("data-bio"),
							250,
						) +
						'                                            <input type="hidden" name="portfolio_managers_selected[]" value="' +
						$valueField.text() +
						" |" +
						manager_id +
						'|">' +
						"                                        </div>" +
						"                                    </div>" +
						"                                </div>" +
						'                                <span class="portfolio-managers__subscriptions-unfollow" data-id="' +
						manager_id +
						'">' +
						localized.preferences.unfollow +
						"</span>" +
						"                            </li>",
				);
		}
	}

	/**
	 * Limits Portfolio Manager Bio to Max Character Limit
	 * @param content
	 * @param limit
	 * @returns {string|*}
	 */
	function portfolio_manager_limit_bio(content, limit) {
		if (content === undefined || content < limit) {
			return content;
		}

		var limitedContent = content.substring(0, limit);

		return (
			'<div class="portfolio-managers__limit">' +
			'	<div class="limited">' +
			limitedContent +
			'... <span class="portfolio-managers__limit-toggle">' +
			localized.more +
			"</span></div>" +
			'	<div class="expanded">' +
			content +
			' <span class="portfolio-managers__limit-toggle">' +
			localized.less +
			"</span></div>" +
			"</div>"
		);
	}

	// Toggle the Bio Limit
	$portfolio_managers_section.on(
		"click",
		".portfolio-managers__limit-toggle",
		function () {
			$(this)
				.closest(".portfolio-managers__limit")
				.toggleClass("portfolio-managers__limit--expanded");
		},
	);

	/**
	 * Remove Portfolio Manager by Id
	 * @param manager_id
	 */
	function remove_portfolio_manager_from_following(manager_id) {
		$portfolio_managers_section
			.find(
				'.portfolio-managers__following [data-manager="' +
					manager_id +
					'"]',
			)
			.remove();

		if (
			$portfolio_managers_section.find(
				".portfolio-managers__subscriptions-unfollow",
			).length === 0
		) {
			// Remove the class that shows the following row
			$portfolio_managers_section
				.find(".row-following")
				.removeClass("row-following--active");
		}
	}

	/**
	 * Find Portfolio Managers by Search Term
	 * @param term
	 * @returns {Array}
	 */
	function find_all_managers_by_search_term(term) {
		var managers = [];

		var $matchesFound = $($portfolio_managers_section)
			.find(
				'#template-subscription-portfolio-managers option:containsNC("' +
					term +
					'")',
			)
			.not('[value=""]');
		$matchesFound.each(function () {
			managers.push({
				name: $(this).text(),
				id: $(this).val(),
			});
		});

		return managers;
	}

	// Follow a portfolio manager by selecting one in the select field
	$portfolio_managers_section
		.find("#template-subscription-portfolio-managers")
		.on("change", function () {
			if ($(this).val()) {
				add_portfolio_manager_to_following($(this).val());
			}

			$(this).val($(this).find("option:first").val());
		});

	// Follow a portfolio manager by clicking on a search result
	$portfolio_managers_section.on(
		"click mouseup enterKey",
		".portfolio-managers__filter-results li",
		function () {
			if ($(this).attr("data-id")) {
				add_portfolio_manager_to_following($(this).attr("data-id"));
			}
		},
	);

	// Unfollow a portfolio manager
	$portfolio_managers_section.on(
		"click enterKey",
		".portfolio-managers__subscriptions-unfollow",
		function () {
			remove_portfolio_manager_from_following($(this).attr("data-id"));
		},
	);

	// Generate portfolio manager search results by search term
	$portfolio_managers_section
		.find(".portfolio-managers__filter-block-input")
		.on("change blur keyup mouseup", function () {
			var filterResults = $(".portfolio-managers__filter-results");
			var managers = find_all_managers_by_search_term($(this).val());
			filterResults.empty();

			if ($(this).val() && managers.length > 0) {
				for (var i = 0; i < managers.length; i++) {
					filterResults.append(
						'<li tabindex="0" data-id="' +
							managers[i].id +
							'">' +
							managers[i].name +
							"</li>",
					);
				}
			} else {
				filterResults.append(
					'<li tabindex="0">' +
						localized.preferences.noresult +
						"</li>",
				);
			}
		});

	/*** SUBSCRIPTION MODULE - FUNDS & TRUSTS ****/
	/**
	 * Add a fund
	 * @param fund_id
	 */

	// Remove the "following" section if it's empty.
	$(".factsheets-commentaries__subscriptions").hide();

	function add_fund_to_following(fund_id) {
		// Display the "following" section.
		$(".factsheets-commentaries__subscriptions").fadeIn();

		// Verify that we are not already following
		if (
			$factsheet_commentaries_section.find(
				'.factsheets-commentaries__subscriptions-unfollow[data-id="' +
					fund_id +
					'"]',
			).length === 0
		) {
			var $valueField = $($factsheet_commentaries_section).find(
				'#template-subscription-factsheets-commentaries option[value="' +
					fund_id +
					'"]',
			);

			// Show the following row if not already
			$factsheet_commentaries_section
				.find(".row-following")
				.addClass("row-following--active");

			// Append the data
			$factsheet_commentaries_section
				.find(".factsheets-commentaries__following")
				.append(
					'<li data-fund="' +
						fund_id +
						'">' +
						'                                <div class="row">' +
						'                                    <div class="col-lg-3">' +
						'                                        <div class="factsheets-commentaries__subscriptions-fund-name">' +
						"                                            " +
						$valueField.text() +
						"                                        </div>" +
						"                                    </div>" +
						'                                    <div class="col-lg-9">' +
						'                                        <div class="factsheets-commentaries__subscriptions-fund-description">' +
						"                                            " +
						$valueField.attr("data-bio") +
						'                                            <input type="hidden" name="factsheets_commentaries_selected[]" value="' +
						$valueField.text() +
						" |" +
						fund_id +
						'|">' +
						"                                        </div>" +
						"                                    </div>" +
						"                                </div>" +
						'                                <span class="factsheets-commentaries__subscriptions-unfollow" data-id="' +
						fund_id +
						'">' +
						localized.preferences.unfollow +
						"</span>" +
						"                            </li>",
				);
			// Fade in the new selection so it's noticable.
			$('[data-fund="' + fund_id + '"]')
				.fadeIn(1000)
				.addClass("fade-in");
		}
	}

	/**
	 * Remove Fund by Id from the "following" section.
	 * @param fund_id
	 */
	function remove_fund_from_following(fund_id) {
		$factsheet_commentaries_section
			.find(
				'.factsheets-commentaries__following [data-fund="' +
					fund_id +
					'"]',
			)
			.remove();
		if (
			$factsheet_commentaries_section.find(
				".factsheets-commentaries__subscriptions-unfollow",
			).length === 0
		) {
			// Remove the class that shows the following row
			$factsheet_commentaries_section
				.find(".row-following")
				.removeClass("row-following--active");
		}

		// Remove the "following" section if it's empty.
		$("ul.factsheets-commentaries__following").each(function () {
			if ($(this).find("li").length == 0) {
				$(".factsheets-commentaries__subscriptions").fadeOut();
			}
		});
	}

	var $registrationFundOptions = $factsheet_commentaries_section
		.find("#template-subscription-factsheets-commentaries option")
		.not(":first")
		.clone();
	/**
	 * Filter Funds by Asset Class Names
	 * @param asset_class_names - Array of Asset Class Names
	 */
	function filter_available_funds(asset_class_names) {
		$factsheet_commentaries_section
			.find("#template-subscription-factsheets-commentaries option")
			.not(":first")
			.remove();

		$registrationFundOptions.each(function () {
			var $option = $(this);
			var asset_classes = $option.attr("data-asset-classes")
				? $option.attr("data-asset-classes").split(",")
				: [];
			var intersections = [];

			for (var i = 0; i < asset_classes.length; i++) {
				if (asset_class_names.indexOf(asset_classes[i]) !== -1) {
					intersections.push(asset_classes[i]);
				}
			}

			if (intersections.length > 0 || asset_class_names.length === 0) {
				$option
					.clone()
					.appendTo("#template-subscription-factsheets-commentaries");
			}
		});
	}

	/**
	 * Find Portfolio Managers by Search Term
	 * @param term
	 * @returns {Array}
	 */
	function find_all_funds_by_search_term(term) {
		var funds = [];

		var $matchesFoundMeta = $factsheet_commentaries_section
			.find(
				'#template-subscription-factsheets-commentaries option[data-product-meta*="' +
					term.toLowerCase() +
					'"]',
			)
			.not("[hidden]")
			.not('[value=""]');

		$matchesFoundMeta.each(function () {
			funds.push({
				name: $(this).text(),
				id: $(this).val(),
			});
		});

		return funds;
	}

	// User selects a fund - allow selection of funds
	$factsheet_commentaries_section
		.find(".asset-classes__block-checkbox")
		.on("change", function () {
			var asset_class_ids = $(
				'[name="filter-factsheets-by-asset-class"]:checked',
			)
				.map(function () {
					return this.value;
				})
				.get();
			filter_available_funds(asset_class_ids);
		});

	// Follow a fund by selecting one in the select field
	$factsheet_commentaries_section
		.find("#template-subscription-factsheets-commentaries")
		.on("change", function () {
			if ($(this).val()) {
				add_fund_to_following($(this).val());
			}

			$(this).val($(this).find("option:first").val());
		});

	// Follow a fund by clicking on a search result
	$factsheet_commentaries_section.on(
		"click mouseup enterKey",
		".factsheets-commentaries__filter-results li",
		function () {
			// User Feedback that the selection has been added.
			var $self = $(this);
			var thisAddedMessageElement = $(this).find(".added-message");
			$(this).addClass("has-add-message");
			thisAddedMessageElement.addClass("show-added-message");
			setTimeout(function () {
				$self.removeClass("has-add-message");
				thisAddedMessageElement.removeClass("show-added-message");
			}, 2000);
			// Add the selection.
			add_fund_to_following($(this).attr("data-id"));
		},
	);

	// Unfollow a portfolio manager
	$factsheet_commentaries_section.on(
		"click enterKey",
		".factsheets-commentaries__subscriptions-unfollow",
		function () {
			remove_fund_from_following($(this).attr("data-id"));
		},
	);

	// Generate portfolio manager search results by search term
	$factsheet_commentaries_section
		.find(".factsheets-commentaries__filter-block-input")
		.on("change blur keyup mouseup", function () {
			var filterResults = $(".factsheets-commentaries__filter-results");
			var funds = find_all_funds_by_search_term($(this).val());
			filterResults.empty();

			if ($(this).val() && funds.length > 0) {
				for (var i = 0; i < funds.length; i++) {
					filterResults.append(
						'<li tabindex="0" data-id="' +
							funds[i].id +
							'">' +
							funds[i].name +
							'<span class="added-message"><span class="jh-icon-Star-Filled"></span><span class="add-message__name">' +
							funds[i].name +
							"</span></li>",
					);
				}
			} else {
				filterResults.append(
					'<li class="no-result" tabindex="0">' +
						localized.preferences.noresult +
						"</li>",
				);
			}
		});

	// When the document is clicked clear search boxes if target is not valid interaction
	$(document).on("click enterKey", function (event) {
		if (
			!$(event.target).closest(".portfolio-managers__filter-block").length
		) {
			$(".portfolio-managers__filter-block-input").val("");
			$(".portfolio-managers__filter-results").empty();
		}

		if (
			!$(event.target).closest(".factsheets-commentaries__filter-block")
				.length
		) {
			$(".factsheets-commentaries__filter-block-input").val("");
			$(".factsheets-commentaries__filter-results").empty();
		}
	});

	/**** REGISTRATION FORM ******
	 *****************************
	 *****************************/

	/**
	 * Go to specific registration page by page number
	 * @param page
	 */
	function go_to_registration_page(page) {
		$($registration_form)
			.find("[data-page]")
			.removeClass("template-subscription__page--active");
		$($registration_form)
			.find("[data-page=" + page + "]")
			.addClass("template-subscription__page--active");
		$("html, body").animate(
			{
				scrollTop:
					$($registration_form)
						.find("[data-page=" + page + "]")
						.offset().top - 50,
			},
			500,
		);
	}

	// Go to next page in registration process
	$registration_form
		.find(".template-subscription__continue-next")
		.on("click enterKey", function () {
			go_to_registration_page(++registration_page);
		});

	// Go to previous page in registration process
	$registration_form
		.find(".template-subscription__continue-back")
		.on("click enterKey", function () {
			go_to_registration_page(--registration_page);
		});

	// Validate changes in registration form
	$registration_form
		.find("[data-required]")
		.on("change blur keyup", function (e) {
			e.preventDefault();
			if ($registration_form.hasClass("has-submitted")) {
				subscription_validate_form($registration_form);
			}
		});

	// Registration Form - Other Role Text Field
	$registration_form
		.find('select[name="userRole"]')
		.on("change", function (e) {
			var $elem = $(this);
			$registration_form.find(".userRoleTextOverride").remove();
			if ($elem.val() === "other") {
				$elem
					.closest(".aside")
					.append(
						'<div class="userRoleTextOverride">' +
							"<br />" +
							'<input type="text" name="userRole" data-required="true" />' +
							"</div>",
					);
			}
		});

	// Submit registration form
	$registration_form
		.find(".template-subscription__submit-button")
		.on("click enterKey", function (e) {
			$registration_form.trigger("submit");
		});

	$registration_form.on("submit", function (e) {
		e.preventDefault();
		var $message = $registration_form.find(".__error");

		if (window.jhCookie.accepted()) {
			var $submitButton = $registration_form.find(
				".template-subscription__submit-button",
			);
			var registerSuccess = false;
			var err = "";

			$message.removeClass("is-showing");
			$message.empty();

			//Disable captcha temporarily
			//if ( subscription_validate_form( $registration_form, true ) === true && ! $submitButton.hasClass( 'disabled' ) && $registration_form.hasClass( 'captcha_verified' ) ) {
			if (
				subscription_validate_form($registration_form, true) === true &&
				!$submitButton.hasClass("disabled")
			) {
				$submitButton.addClass("disabled loading");

				$.ajax({
					type: "POST",
					url: localized.ajax_url,
					data: $registration_form.serialize(),
					error: function (data, status, xhr) {
						$message.addClass("is-showing");
						$message.text(localized.preferences.genericError);
						jh_log_subscriptions_ajax_errors(
							"REGISTRATION::AJAX Call Failed",
							xhr.status,
							JSON.stringify(xhr),
							$registration_form.serialize(),
						);
					},
					success: function (data, status, xhr) {
						data = JSON.parse(data);

						if (data.success) {
							registerSuccess = true;
							// Initial load of subscribed content not appearing due to this localStorage item never being set after registration
							window.localStorage.setItem(
								"pardot-session-data",
								JSON.stringify(data.pardot_session_data.data),
							);
							location.reload();
						} else {
							$message.addClass("is-showing");
							$message.text(data.message);
							err = data.message;
							jh_log_subscriptions_ajax_errors(
								"REGISTRATION::AJAX Call Succeeded But Invalid Response",
								xhr.status,
								JSON.stringify(xhr),
								$registration_form.serialize(),
							);
						}
					},
					complete: function () {
						if (!registerSuccess) {
							$registration_form.removeClass("submitting");
							$submitButton.removeClass("disabled loading");
						}
						//For Analytics tracking
						gtmHelper.userRegisterEvent(registerSuccess, err);
					},
				});
			}
		} else {
			$message.addClass("is-showing");
			$message.text(localized.cookie.must_agree);
			$(".cookie-acceptance__accept").focus();
			jh_log_subscriptions_ajax_errors(
				"REGISTRATION::Cookies not accepted.",
				"No Ajax Call Made",
				"No Ajax Call Made",
				$registration_form.serialize(),
			);
		}
	});

	/**** SIGN UP CITY FILTERING BY COUNTRY ******
	 *****************************
	 *****************************/
	var states_by_country = {
		// "UK": {
		// 	'I1': 'Aberdeen City', 'I2': 'Aberdeenshire', 'I3': 'Anglesey', 'I4': 'Angus', 'I5': 'Antrim', 'I6': 'Argyll and Bute', 'I7': 'Armagh', 'I8': 'Avon', 'I9': 'Ayrshire', 'IB': 'Bath and NE Somerset', 'IC': 'Bedfordshire', 'IE': 'Belfast', 'IF': 'Berkshire', 'IG': 'Berwickshire', 'IH': 'BFPO', 'II': 'Blaenau Gwent', 'IJ': 'Buckinghamshire', 'IK': 'Caernarfonshire', 'IM': 'Caerphilly', 'IO': 'Caithness', 'IP': 'Cambridgeshire', 'IQ': 'Cardiff', 'IR': 'Cardiganshire', 'IS': 'Carmarthenshire', 'IT': 'Ceredigion', 'IU': 'Channel Islands', 'IV': 'Cheshire', 'IW': 'City of Bristol', 'IX': 'Clackmannanshire', 'IY': 'Clwyd', 'IZ': 'Conwy', 'J0': 'Cornwall/Scilly', 'J1': 'Cumbria', 'J2': 'Denbighshire', 'J3': 'Derbyshire', 'J4': 'Derry/Londonderry', 'J5': 'Devon', 'J6': 'Dorset', 'J7': 'Down', 'J8': 'Dumfries and Galloway', 'J9': 'Dunbartonshire', 'JA': 'Dundee', 'JB': 'Durham', 'JC': 'Dyfed', 'JD': 'East Ayrshire', 'JE': 'East Dunbartonshire', 'JF': 'East Lothian', 'JG': 'East Renfrewshire', 'JH': 'East Riding Yorkshire', 'JI': 'East Sussex', 'JJ': 'Edinburgh', 'JK': 'England', 'JL': 'Essex', 'JM': 'Falkirk', 'JN': 'Fermanagh', 'JO': 'Fife', 'JP': 'Flintshire', 'JQ': 'Glasgow', 'JR': 'Gloucestershire', 'JS': 'Greater London', 'JT': 'Greater Manchester', 'JU': 'Gwent', 'JV': 'Gwynedd', 'JW': 'Hampshire', 'JX': 'Hartlepool', 'HAW': 'Hereford and Worcester', 'JY': 'Hertfordshire', 'JZ': 'Highlands', 'K0': 'Inverclyde', 'K1': 'Inverness-Shire', 'K2': 'Isle of Man', 'K3': 'Isle of Wight', 'K4': 'Kent', 'K5': 'Kincardinshire', 'K6': 'Kingston Upon Hull', 'K7': 'Kinross-Shire', 'K8': 'Kirklees', 'K9': 'Lanarkshire', 'KA': 'Lancashire', 'KB': 'Leicestershire', 'KC': 'Lincolnshire', 'KD': 'Londonderry', 'KE': 'Merseyside', 'KF': 'Merthyr Tydfil', 'KG': 'Mid Glamorgan', 'KI': 'Mid Lothian', 'KH': 'Middlesex', 'KJ': 'Monmouthshire', 'KK': 'Moray', 'KL': 'Neath & Port Talbot', 'KM': 'Newport', 'KN': 'Norfolk', 'KP': 'North Ayrshire', 'KQ': 'North East Lincolnshire', 'KR': 'North Lanarkshire', 'KT': 'North Lincolnshire', 'KU': 'North Somerset', 'KV': 'North Yorkshire', 'KO': 'Northamptonshire', 'KW': 'Northern Ireland', 'KX': 'Northumberland', 'KZ': 'Nottinghamshire', 'L0': 'Orkney and Shetland Isles', 'L1': 'Oxfordshire', 'L2': 'Pembrokeshire', 'L3': 'Perth and Kinross', 'L4': 'Powys', 'L5': 'Redcar and Cleveland', 'L6': 'Renfrewshire', 'L7': 'Rhonda Cynon Taff', 'L8': 'Rutland', 'L9': 'Scottish Borders', 'LB': 'Shetland', 'LC': 'Shropshire', 'LD': 'Somerset', 'LE': 'South Ayrshire', 'LF': 'South Glamorgan', 'LG': 'South Gloucesteshire', 'LH': 'South Lanarkshire', 'LI': 'South Yorkshire', 'LJ': 'Staffordshire', 'LK': 'Stirling', 'LL': 'Stockton On Tees', 'LM': 'Suffolk', 'LN': 'Surrey', 'LO': 'Swansea', 'LP': 'Torfaen', 'LQ': 'Tyne and Wear', 'LR': 'Tyrone', 'LS': 'Vale Of Glamorgan', 'LT': 'Wales', 'LU': 'Warwickshire', 'LV': 'West Berkshire', 'LW': 'West Dunbartonshire', 'LX': 'West Glamorgan', 'LY': 'West Lothian', 'LZ': 'West Midlands', 'M0': 'West Sussex', 'M1': 'West Yorkshire', 'M2': 'Western Isles', 'M3': 'Wiltshire', 'M4': 'Wirral', 'M5': 'Worcestershire', 'M6': 'Wrexham', 'M7': 'York'
		// },
		US: {
			AL: "Alabama",
			AK: "Alaska",
			AZ: "Arizona",
			AR: "Arkansas",
			CA: "California",
			CO: "Colorado",
			CT: "Connecticut",
			DE: "Delaware",
			DC: "District Of Columbia",
			FL: "Florida",
			GA: "Georgia",
			HI: "Hawaii",
			ID: "Idaho",
			IL: "Illinois",
			IN: "Indiana",
			IA: "Iowa",
			KS: "Kansas",
			KY: "Kentucky",
			LA: "Louisiana",
			ME: "Maine",
			MD: "Maryland",
			MA: "Massachusetts",
			MI: "Michigan",
			MN: "Minnesota",
			MS: "Mississippi",
			MO: "Missouri",
			MT: "Montana",
			NE: "Nebraska",
			NV: "Nevada",
			NH: "New Hampshire",
			NJ: "New Jersey",
			NM: "New Mexico",
			NY: "New York",
			NC: "North Carolina",
			ND: "North Dakota",
			OH: "Ohio",
			OK: "Oklahoma",
			OR: "Oregon",
			PA: "Pennsylvania",
			RI: "Rhode Island",
			SC: "South Carolina",
			SD: "South Dakota",
			TN: "Tennessee",
			TX: "Texas",
			UT: "Utah",
			VT: "Vermont",
			VA: "Virginia",
			WA: "Washington",
			WV: "West Virginia",
			WI: "Wisconsin",
			WY: "Wyoming",
		},
	};
	var $userSignupCountryField = $userSignup.find('[name="userCountry"]');
	var $userSignupStateField = $userSignup.find('[name="userState"]');
	var signUpCountryOptions = $.map(
		$userSignupCountryField.find("option"),
		function (option) {
			return option.value;
		},
	);

	function update_states_field_by_current_country(country) {
		// Clear the state/province options
		$userSignupStateField.find("option").not(":first").remove();

		// Populate the state/province options OR hide the field group
		if (
			$userSignupStateField &&
			states_by_country.hasOwnProperty(country)
		) {
			var states = states_by_country[country];

			for (var k in states) {
				if (states.hasOwnProperty(k)) {
					$userSignupStateField.append(
						'<option value="' + k + '">' + states[k] + "</option>",
					);
				}
			}

			$userSignupStateField
				.closest(".user-signup__form-group")
				.removeClass("user-signup__form-group--hidden");
		} else {
			$userSignupStateField
				.closest(".user-signup__form-group")
				.addClass("user-signup__form-group--hidden");
		}
	}

	// Populate State on Country Change
	$userSignupCountryField.on("change", function () {
		update_states_field_by_current_country($(this).val());
	});

	// Populate Country on Page Load
	if (
		localized.country &&
		signUpCountryOptions.indexOf(localized.country.toUpperCase()) > -1
	) {
		$userSignupCountryField.val(localized.country.toUpperCase());
	}
	update_states_field_by_current_country(localized.country.toUpperCase());

	/**** UPDATE PREFERENCES FORM ******
	 *****************************
	 *****************************/

	// Populate the Update Preferences Form
	if ($update_form.length > 0 && pardot_data && pardot_data.token) {
		// Populate token
		$update_form.find('[name="token"]').val(pardot_data.token);

		// Get the pardotLists from locationStorage
		// Populate Pardot Preferences
		if (
			pardot_data_location_storage &&
			pardot_data_location_storage.pardotLists
		) {
			for (
				var i = 0;
				i < pardot_data_location_storage.pardotLists.length;
				i++
			) {
				$update_form
					.find(
						'[name="pardot-preferences[]"][value="' +
							pardot_data_location_storage.pardotLists[i].listId +
							'"]',
					)
					.prop("checked", true)
					.trigger("change");
			}
		}

		// Populate Porfolio Managers
		for (var i = 0; i < pardot_data.personFollows.length; i++) {
			var portfolio_manager_id =
				pardot_data.personFollows[i].split("|")[1];
			add_portfolio_manager_to_following(portfolio_manager_id);
		}

		// Populate Funds
		for (var i = 0; i < pardot_data.productFollows.length; i++) {
			var fund_id = pardot_data.productFollows[i].split("|")[1];
			add_fund_to_following(fund_id);
		}
	}

	// Submit update form
	$update_form
		.find(".template-subscription__submit-button")
		.on("click enterKey", function (e) {
			$update_form.trigger("submit");
		});

	// Form triggered by recaptcha fields check
	$update_form.on("submit", function (e) {
		e.preventDefault();
		if (window.jhCookie.accepted()) {
			var $submitButton = $update_form.find(
				".template-subscription__submit-button",
			);
			var $message = $(scoped).find(
				".template-subscription__dashboard-update",
			);

			$message
				.empty()
				.removeClass("template-subscription__dashboard-update--error");

			// Disable Captcha Temporarily
			//if ( subscription_validate_form( $update_form, true ) === true && ! $submitButton.hasClass( 'disabled' ) && $update_form.hasClass( 'captcha_verified' ) ) {
			if (
				subscription_validate_form($update_form, true) === true &&
				!$submitButton.hasClass("disabled")
			) {
				$submitButton.addClass("disabled loading");
				// Update form with pardotLists
				// console.log( JSON.stringify( pardot_data_location_storage.pardotLists ) );
				$update_form
					.find('input[name="pardot_lists"]')
					.val(
						JSON.stringify(
							pardot_data_location_storage.pardotLists,
						),
					);

				$.ajax({
					type: "POST",
					url: localized.ajax_url,
					data: $update_form.serialize(),
					error: function (data, status, xhr) {
						$message
							.text(localized.preferences.genericError)
							.addClass(
								"template-subscription__dashboard-update--error",
							);
						jh_log_subscriptions_ajax_errors(
							"UPDATE FORM::AJAX Call Failed",
							xhr.status,
							JSON.stringify(xhr),
							$update_form.serialize(),
						);
					},
					success: function (data, status, xhr) {
						data = JSON.parse(data);
						if (data.success) {
							$message.text(data.message).focus();
							window.localStorage.setItem(
								"pardot-session-data",
								JSON.stringify(data.pardot_session_data.data),
							);
							location.reload();
						} else if (data.redirect) {
							window.location.replace(data.redirect);
							jh_log_subscriptions_ajax_errors(
								"UPDATE(REDIRECT)::AJAX Call Succeeded But Invalid Response",
								xhr.status,
								JSON.stringify(xhr),
								$update_form.serialize(),
							);
						} else {
							$message
								.text(data.message)
								.addClass(
									"template-subscription__dashboard-update--error",
								)
								.focus();
							jh_log_subscriptions_ajax_errors(
								"UPDATE::AJAX Call Succeeded But Invalid Response",
								xhr.status,
								JSON.stringify(xhr),
								$update_form.serialize(),
							);
						}
					},
					complete: function () {
						$update_form.removeClass("submitting");
						$submitButton.removeClass("disabled loading");
						$("html, body").animate(
							{
								scrollTop: 0,
							},
							500,
						);
					},
				});
			}
		} else {
			var $message = $(this).closest("form").find(".__error");
			$message.text(localized.cookie.must_agree);
			$(".cookie-acceptance__accept").focus();
			jh_log_subscriptions_ajax_errors(
				"LOGIN::Cookies not accepted.",
				"No Ajax Call Made",
				"No Ajax Call Made",
				$login_form.serialize(),
			);
		}
	});

	/**** LOGIN FORM ******
	 *****************************
	 *****************************/

	$login_form
		.find(".template-subscription__submit-button")
		.on("click enterKey", function (e) {
			$login_form.trigger("submit");
		});

	$login_form
		.find('[name="subscription_preferences_cookie_consent"]')
		.on("change", function () {
			var $message = $login_form.find(".__error");

			if (this.checked) {
				window.jhCookie.set("cookies_accepted", "true", 360);
				$message.removeClass("is-showing").empty();
			}
		});

	$login_form.on("submit", function (e) {
		e.preventDefault();

		var $consentCheckbox = $(this).find(
			'[name="subscription_preferences_cookie_consent"]',
		);
		var $consentCheckboxGroup = $consentCheckbox.closest(
			".user-login__form-group--checkbox",
		);
		var $message = $(this).find(".__error");

		if (!window.jhCookie.accepted() && $consentCheckbox.is(":checked")) {
			window.jhCookie.set("cookies_accepted", "true", 360);
		}

		if (window.jhCookie.accepted()) {
			var $submitButton = $(this).find(
				".template-subscription__submit-button",
			);
			var loginSuccess = false;
			var err = "";
			var $redirectProspectFooter = "";

			$login_form.find(".__error").empty();

			// Disable captcha temporarily
			// if ( subscription_validate_form( $login_form, true ) === true && ! $submitButton.hasClass( 'disabled' ) && $login_form.hasClass( 'captcha_verified' ) ) {
			if (
				subscription_validate_form($login_form, true) === true &&
				!$submitButton.hasClass("disabled")
			) {
				$message.addClass("is-showing");
				$message.empty();
				$submitButton.addClass("disabled loading");

				$.ajax({
					type: "POST",
					url: localized.ajax_url,
					data: $login_form.serialize(),
					error: function (data, status, xhr) {
						$message.text(localized.preferences.genericError);
						jh_log_subscriptions_ajax_errors(
							"LOGIN::AJAX Call Failed",
							xhr.status,
							JSON.stringify(xhr),
							$login_form.serialize(),
						);
					},
					success: function (data, status, xhr) {
						data = JSON.parse(data);

						if (data.show_modal.status) {
							// Redirect Prospect Modal form
							$redirect_prospect_modal_form
								.find(".userEmail")
								.val($login_form.find("#userEmail").val());
							$redirect_prospect_modal_form
								.find(".site_code")
								.val(data.show_modal.site_code);
							$redirect_prospect_modal_form
								.find(".site_language")
								.val(data.show_modal.site_lang);
							$redirect_prospect_modal_form
								.find(".redirect_prospect_url")
								.val(data.show_modal.redirect_prospect_url);
							$redirect_prospect_modal_form
								.find(".cookie_path")
								.val(data.show_modal.cookie_path);

							$redirectProspectFooter =
								'<div class="redirect-prospect-modal-acceptance">' +
								'<span class="jh-btn ghost with-icon icon-r icon-arrow redirect-prospect-stay" onClick="window.modal.close()" tabindex="0">' +
								localized.preferences
									.redirectProspectStayButton +
								"</span>" +
								'<span class="jh-btn primary with-icon icon-r icon-arrow redirect-prospect-continue" tabindex="0">' +
								localized.preferences
									.redirectProspectContinueButton +
								"</span>" +
								"</div>";

							window.modal.dynamic_open(
								false,
								localized.preferences.redirectProspectBody.replace(
									/\[.*?\]/,
									data.show_modal.blog_name,
								),
								false,
								false,
								$redirectProspectFooter,
								"js-subscription-registered-offsite-modal",
							);
						} else {
							if (data.success) {
								loginSuccess = true;
								window.localStorage.setItem(
									"pardot-session-data",
									JSON.stringify(
										data.pardot_session_data.data,
									),
								);
								location.reload();
							} else {
								$message.html(data.message);
								err = data.message;
								jh_log_subscriptions_ajax_errors(
									"LOGIN::AJAX Call Succeeded But Invalid Response",
									xhr.status,
									JSON.stringify(xhr),
									$login_form.serialize(),
								);
							}
						}
					},
					complete: function () {
						if (!loginSuccess) {
							$login_form.removeClass("submitting");
							$submitButton.removeClass("disabled loading");
						}
						//For Analytics tracking
						gtmHelper.userLoginEvent(loginSuccess, err);
					},
				});
			}
		} else {
			$consentCheckboxGroup.removeClass(
				"user-login__form-group--checkbox-hidden",
			);
			$message.addClass("is-showing");
			$message.text(localized.cookie.must_agree);
			$consentCheckbox.trigger("focus");
			jh_log_subscriptions_ajax_errors(
				"LOGIN::Cookies not accepted.",
				"No Ajax Call Made",
				"No Ajax Call Made",
				$login_form.serialize(),
			);
		}
	});

	// Clear session data on logout.
	$("a[href$='?logout=true']").click(function () {
		window.localStorage.removeItem("pardot-session-data");
	});

	/**** REDIRECT PROSPECT MODAL ******
	 *****************************
	 *****************************/

	/**
	 * Redirect prospect modal: Closing the modal on 'stay' button click
	 */
	$redirect_prospect_modal.on(
		"click",
		".redirect-prospect-stay",
		function () {
			$("#js-subscription-registered-offsite-modal").modal("hide");
		},
	);

	/**
	 * Redirect prospect modal: Redirecting the user to registered subscription spoke
	 */
	$redirect_prospect_modal.on(
		"click",
		".redirect-prospect-continue",
		function () {
			var loginSuccess = false;
			var err = "";
			var $continueToNewSite = $redirect_prospect_modal.find(
				".redirect-prospect-continue",
			);

			$continueToNewSite.addClass("loading");
			$.ajax({
				type: "POST",
				url: localized.ajax_url,
				data: $redirect_prospect_modal_form.serialize(),
				error: function (data, status, xhr) {
					jh_log_subscriptions_ajax_errors(
						"LOGIN::AJAX Call Failed",
						xhr.status,
						JSON.stringify(xhr),
						$redirect_prospect_modal_form.serialize(),
					);
				},
				success: function (data, status, xhr) {
					data = JSON.parse(data);
					if (data.success) {
						loginSuccess = true;

						window.localStorage.setItem(
							"pardot-session-data",
							JSON.stringify(data.pardot_session_data.data),
						);
						window.location.replace(data.redirect_prospect_url);
					} else {
						jh_log_subscriptions_ajax_errors(
							"LOGIN::AJAX Call Succeeded But Invalid Response",
							xhr.status,
							JSON.stringify(xhr),
							$redirect_prospect_modal_form.serialize(),
						);
					}
				},
				complete: function () {
					if (!loginSuccess) {
						$redirect_prospect_modal_form.removeClass("submitting");
						$continueToNewSite.removeClass("loading");
					}
				},
			});
		},
	);

	/**
	 * Delete Account
	 */

	// Populate the Delete Preferences Form
	if ($delete_form.length > 0 && pardot_data && pardot_data.token) {
		$delete_form.find('[name="token"]').val(pardot_data.token);
	}

	scoped
		.find("#delete-my-account-modal .modal-button--confirm")
		.click(function (e) {
			e.preventDefault();
			scoped
				.find("#delete-my-account-modal .modal-button--close")
				.trigger("click");

			var $message = $(scoped).find(
				".template-subscription__dashboard-update",
			);
			$message
				.text("Deleting Account...")
				.removeClass("template-subscription__dashboard-update--error");

			$.ajax({
				type: "POST",
				url: localized.ajax_url,
				data: $delete_form.serialize(),
				error: function (data, status, xhr) {
					$message
						.text(localized.preferences.genericError)
						.addClass(
							"template-subscription__dashboard-update--error",
						);
					jh_log_subscriptions_ajax_errors(
						"DELETE ACCOUNT::AJAX Call Failed",
						xhr.status,
						JSON.stringify(xhr),
						$delete_form.serialize(),
					);
				},
				success: function (data, status, xhr) {
					data = JSON.parse(data);
					if (data.success) {
						$message.text(data.message);
						location.reload();
					} else {
						$message
							.text(data.message)
							.addClass(
								"template-subscription__dashboard-update--error",
							);
						jh_log_subscriptions_ajax_errors(
							"DELETE ACCOUNT::AJAX Call Succeeded But Invalid Response",
							xhr.status,
							JSON.stringify(xhr),
							$delete_form.serialize(),
						);
					}
				},
				complete: function () {},
			});
		});

	/**
	 * Toggle Selection
	 */
	$subscription_toggle.on("change", function () {
		if ($(this).is(":checked")) {
			scoped
				.find('[name^="pardot-preferences"]')
				.attr("checked", true)
				.trigger("change");
		} else {
			scoped
				.find('[name^="pardot-preferences"]')
				.attr("checked", false)
				.trigger("change");
		}
	});

	/**** FACTSHEET/COMMENTARY DOCUMENTS ******
	 *****************************
	 *****************************/
	$document_table
		.find(".user-factsheets__factsheet")
		.on("click", function () {
			var $row = $(this).closest("tr");
			var product_id = $row.attr("data-product-id");
			var share_class = $row.find('[name="share-class"]').val();
			document_request(product_id, "Factsheet", share_class);
		});

	function document_request(product_id, type, share_class) {
		var $request_document_form = $("#form-request-fund-document");
		$request_document_form.find('[name="fund_id"]').val(product_id);
		$request_document_form.find('[name="document_type"]').val(type);
		$request_document_form.find('[name="share_class"]').val(share_class);

		if (localized.preferences.documentRequestTitle === null) {
			localized.preferences.documentRequestTitle = "";
		}

		if (localized.preferences.documentRequestContent === null) {
			localized.preferences.documentRequestContent = "";
		}

		window.modal.dynamic_open(
			localized.preferences.documentRequestTitle,
			localized.preferences.documentRequestContent,
			true,
		);

		$.ajax({
			type: "POST",
			url: localized.ajax_url,
			data: $request_document_form.serialize(),
			error: function (data, status, xhr) {
				$(window.modal.selector)
					.find(".modal-body__content")
					.html(localized.preferences.genericError);
				jh_log_subscriptions_ajax_errors(
					"DOCUMENT REQUEST::AJAX Call Failed",
					xhr.status,
					JSON.stringify(xhr),
					$login_form.serialize(),
				);
			},
			success: function (data, status, xhr) {
				data = JSON.parse(data);
				$(window.modal.selector)
					.find(".modal-body__content")
					.html(data.message);
			},
			complete: function () {},
		});
	}

	/**
	 * Log frontend errors in the PHP error log via jh_log_subscriptions_errors()
	 *
	 * @param error_type string Description of the error that occurred.
	 * @param status_code string The HTTP status code of the AJAX call.
	 * @param response_message object The raw response data from the AJAX call.
	 * @param user_data string|serialized The form data submitted to the AJAX call.
	 */
	function jh_log_subscriptions_ajax_errors(
		error_type,
		status_code,
		response_message,
		user_data,
	) {
		$.ajax({
			type: "POST",
			url: localized.ajax_url,
			data: {
				action: "jh_log_subscriptions_errors",
				error_type: error_type,
				response_code: status_code,
				response_message: response_message,
				user_data: user_data,
			},
			error: function (data, status, xhr) {
				console.log(JSON.stringify(xhr));
			},
			success: function (data, status, xhr) {
				// Nothing to do here. Everything is logged on the PHP side.
			},
			complete: function () {},
		});
	}
})(window, document, jQuery);

// User Insights load via localStorage
(function (window, document, $, undefined) {
	$(window).on("load", function () {
		// Preferences post ID
		var preferences_post_ID = $(".subscription-preferences-insights")
			.find(".post-id")
			.data("id");
		var baseURL = encodeURI($(location).attr("href"));
		baseURL = baseURL.replace("-source/", "/");

		if (preferences_post_ID) {
			// Show the 'loading' overlay
			$(".loading-overlay").show();
			$.ajax({
				type: "POST",
				url: localized.ajax_url,
				dataType: "HTML",
				data: {
					action: "jh_pardot_ls",
					postIDs:
						window.localStorage.getItem("pardot-session-data") ||
						{},
					baseURL: baseURL,
					postID: $(".subscription-preferences-insights")
						.find(".post-id")
						.data("id"),
				},
				error: function (data, status, xhr) {
					console.log(data);
					console.log(JSON.stringify(xhr));
				},
				success: function (data, status, xhr) {
					// Hide the overlay on success
					$(".loading-overlay").hide();
					if (data === "" || data === false) {
						$(".template-subscription")
							.find(".preferences-insights-block")
							.html("<p>No Results Found</p>");
					} else {
						$(".template-subscription")
							.find(".preferences-insights-block")
							.html(data);
					}
				},
				complete: function () {},
			});
		}
	});
})(window, document, jQuery);
